/* ===== 1.Осноные компоненты react ===== */
import { Routes, Route } from 'react-router-dom';

/* ===== 2.Локальные компоненты ===== */
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";

/* ===== 3.Локальные компоненты Базы данных ===== */
import footerData from "./data/footer";

/* ===== Страницы ( Pages ) ===== */
import Home from "./pages/Home";
import NotFound from "./pages/NotFoundPage";
import Privacy from "./pages/Privacy/Privacy";

/* ===== 3.Картинки и прочее ===== */

/* ===== 4.Стили ===== */

/* ===== 3.Картинки и прочее ===== */

/* ===== 4.Стили ===== */


function App() {
  return (
    <>
      <Header />
      <main className='mainContainer'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          {/* <--- Добавьте маршрут 404 ВСЕГДА ПОСЛЕДНИМ! ---> */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </main>
      <Footer data={footerData} />
    </>
  );
}

export default App;
